<template>
    <zj-layout-container class="zj-plan-manage">
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor">
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="first">
              <ComponentPlanDetail :query="queryProp" @ChangeTab="ChangeTab" />
            </el-tab-pane>
            <el-tab-pane label="任务管理" v-if="IsEdit" name="second">
              <ComponentTaskList
                v-if="!TaskDetailVisible"
                @addDetial="addDetial"
                @editDetial="editDetial"
                @handleDetial="handleDetial"
                :planId="planId"
                :query="queryProp"
              />
              <ComponentTaskInfo v-else @backList="backList" :planId="planId" :id="id" :IsEditTask="IsEditInfo"/>
            </el-tab-pane>
            <el-tab-pane label="附件管理" v-if="IsEdit" name="third">
              <ComponentAttachList :planId="planId"/>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-button
          @click="onBack()"
          style="width: 18rem;position: absolute;margin-top: 1rem;right: 4.5rem;"
        >返回预案管理</el-button>
      </zj-layout-main>
    </zj-layout-container>
</template>

<script>
import ComponentPlanDetail from "./PlanDetail";
import ComponentTaskList from "./TaskList";
import ComponentAttachList from "./AttachList";
import ComponentTaskInfo from "./TaskInfo";

export default {
  name: "ZjPlanManage",
  controller: "UI",
  action: "PlanManage",
  components: {
    ComponentPlanDetail: ComponentPlanDetail,
    ComponentTaskList: ComponentTaskList,
    ComponentAttachList: ComponentAttachList,
    ComponentTaskInfo: ComponentTaskInfo
  },
  props: {
    query: {
      id: String,
      type: String
    }
  },
  data() {
    return {
      activeName: "first",
      IsEdit: false,
      TaskDetailVisible: false,
      planId: "",
      queryProp: this.query,
      id:""
    };
  },
  created: function() {
    this.IsEdit = this.query.id == null ? false : true;
    if (this.query.id) {
      this.planId = this.query.id;
    }
  },
  methods: {
    addDetial() {
      this.id = '';
      this.IsEditInfo=false;
      this.TaskDetailVisible = true;
    },
    backList() {
      this.TaskDetailVisible = false;
    },
    editDetial(Id) {
      this.id = Id;
      this.IsEditInfo=false;
      this.TaskDetailVisible = true;
    },
    handleDetial(Id) {
      this.id = Id;
      this.IsEditInfo=true;
      this.TaskDetailVisible = true;
    }, //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    ChangeTab(id){
      this.activeName=id;
    }
  },
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        if(val != oldVal)
        // eslint-disable-next-line no-undef
        this.planId =  this.query.id;
        this.queryProp = this.query;
      },
      immediate: true,
      deep: true,
    },
  }
};
</script>

<style lang="scss">
.zj-plan-manage .el-tabs {
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}
.zj-plan-manage .el-tabs.el-tabs--left {
  flex-direction: row;
}
.zj-plan-manage .el-tabs__header {
  flex: 0 0 auto;
}
.zj-plan-manage .el-tabs--top > .el-tabs__header {
  border-bottom: 1px dashed #3d9fff;
}
.zj-plan-manage .el-tabs__content {
  flex: 1 1 auto;
}
.zj-plan-manage .el-tab-pane {
  height: 100%;
  overflow: hidden;
}
.zj-plan-manage .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
.zj-plan-manage .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 2rem;
}

.zj-plan-manage .el-tabs--top .el-tabs__item {
  color: #acb8c7;
  font-size: 1.6rem;
}

.zj-plan-manage .el-tabs--top .el-tabs__item.is-active {
  color: #ffffff;
  font-size: 1.6rem;
}

.zj-plan-manage .el-tabs--top .el-tabs__item:hover {
  color: #ffffff;
  font-size: 1.6rem;
  cursor: pointer;
}

.zj-plan-manage .el-tabs--top .el-tabs__nav {
  padding-bottom: 1rem;
}

.zj-plan-manage .el-tabs--top .el-tabs__nav-next,
.zj-plan-manage .el-tabs__nav-prev {
  font-size: 1.6rem;
  color: #2ac1ff;
}

.zj-plan-manage .el-tabs--top .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.zj-plan-manage
  .el-tabs--top
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__active-bar {
  bottom: 1.2rem;
  height: 2px;
  background-color: #409eff;
  border-radius: 2px;
  box-shadow: 0px 0.5rem 0.5rem rgba(64, 158, 255, 0.7);
}
.zj-plan-manage
  .el-tabs.no-active-bar
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__active-bar {
  display: none;
}
.zj-plan-manage
  .el-tabs--left
  > .el-tabs__header
  > .el-tabs__nav-wrap::after {
  background-color: rgba(42, 193, 255, 0.2)/*#2ac1ff*/;
  width: 2px;
}
.zj-plan-manage
  .el-tabs--left
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__item {
  color: white;
  font-size: 1.5rem;
  &.is-active {
    color:#409eff;
  }
}
.zj-plan-manage
  .user-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__item {
  font-size: 1.5rem;
}
.zj-plan-manage .divider-bar {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.zj-plan-manage .download-link,
.zj-plan-manage .download-link:active {
  text-decoration: none;
  color: #298beb;
}
.zj-plan-manage .download-link:hover {
  text-decoration: none;
  color: #54a2ef;
}
.zj-plan-manage .zj-user-list {
  margin: 0rem 0rem 0rem 3rem;
  .el-checkbox {
    width: 10.5rem;
    margin-right: 1rem;
  }
}
</style>
